export default function ErrorModal(props){
    return (
        <div
  className="modal fade text-left show"
  id="verify_modal"
  tabIndex={-1}
  role="dialog"
  style={{ display: "block", paddingRight: 15, zIndex:1060 }}
>
  <div
    className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    role="document"
  >
    <div className="modal-content">
      <div className="modal-header bg-danger">
        <h6 className="modal-title">{props.title}</h6>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={() => props.closeErrorModal()}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body">
        <strong>Message: {props.errorMsg}</strong>
        <br />
      </div>
      <div className="modal-footer">
        <button
          className="btn btn-primary"
          onClick={() => props.closeErrorModal()}
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
    );
}